import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import classNames from 'classnames';
import { useMemo } from 'react';
import { type IntlShape, useIntl } from 'react-intl';

import { Filter, getOption } from '#components/shared/Filter.tsx';
import { FilterResetButton } from '#components/shared/FilterResetButton.tsx';
import { SearchInput } from '#components/shared/SearchInput.tsx';

import { TourStatusData } from './TourStatusData.ts';

const getOptions = (intl: IntlShape) => [
    getOption('problem', TourStatusData, intl),
    getOption('in-transit', TourStatusData, intl),
    getOption('planned', TourStatusData, intl),
    getOption('finished', TourStatusData, intl),
];

type TourTableToolbarProps = {
    search: string;
    onSearch: (value: string) => void;
    statusFilter: string[];
    onFilterStatus: (input: string[]) => void;
    onRefresh: () => void;
    isRefreshing: boolean;
    onResetStatusFilter: () => void;
};

export const TourTableToolbar = ({
    search,
    onSearch,
    statusFilter,
    onFilterStatus,
    onRefresh,
    isRefreshing,
    onResetStatusFilter,
}: TourTableToolbarProps) => {
    const intl = useIntl();
    const options = useMemo(() => getOptions(intl), [intl]);

    return (
        <TableToolbar>
            <div className='table-toolbar-container'>
                <div className='table-toolbar-group-right'>
                    <div className='table-toolbar-column'>
                        <FilterResetButton statusFilter={statusFilter} onResetStatusFilter={onResetStatusFilter} />
                    </div>
                    <div className='table-toolbar-column table-toolbar-column-spacer'>
                        <Filter onFilter={onFilterStatus} options={options} values={statusFilter} />
                    </div>
                    <div className='table-toolbar-column table-toolbar-column-spacer'>
                        <SearchInput onSearch={onSearch} value={search} />
                    </div>
                    <div className='table-toolbar-column'>
                        <button
                            type='button'
                            className='btn btn-default btn-icon-only'
                            onClick={onRefresh}
                            data-testid='refresh-button'
                        >
                            <span
                                className={classNames('rioglyph rioglyph-refresh', { spinning: isRefreshing })}
                                aria-hidden='true'
                            />
                        </button>
                    </div>
                </div>
            </div>
        </TableToolbar>
    );
};
